import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class SympsISED extends Component {

    componentDidMount = () => {
        console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">


          <div className="new_banner">
            <div className="banner_content">
              <h1>CSCI 2023</h1>
              <h6>The 2023 International Conference on</h6>
              <h6>Computational Science and Computational Intelligence (CSCI)</h6>
              <h6>December 13-15, 2023, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Research Track on Education (CSCI-RTED)</h4>
            <div className="par">
            All accepted papers of all Research Tracks will be published by Conference Publishing Services, <a target="_blank" href="https://www.computer.org/conferences/cps">CPS </a>
            as part of the proceedings of The 2023 International Conference on Computational Science and Computational Intelligence (CSCI'23).
            <br/>
            Past conference proceedings can be accessed via IEEE Xplore Digital Library at: <br/> <br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/tocresult.jsp?isnumber=6822065">Volume I (2014)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/tocresult.jsp?isnumber=6822285">Volume II (2014)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/mostRecentIssue.jsp?punumber=7420813">Volume (2015)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/mostRecentIssue.jsp?punumber=7879541">Volume (2016)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/mostRecentIssue.jsp?punumber=8554238">Volume (2017)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/8859311/proceeding">Volume (2018)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/9052554/proceeding">Volume (2019)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/9457837/proceeding">Volume (2020)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/9798893/proceeding">Volume (2021)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/10216364/proceeding">Volume (2022)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/1803739/all-proceedings">All CSCI Proceedings</a><br/>

            <br/>
            Since its inception, all CSCI proceedings have always been approved and included
                into IEEE Xplore indexation/digital-library citation databases. The proceedings
                of CSCI have also been included in other major citation index systems (including,
                Ei Compendex, <a href="http://www.engineeringvillage.com" target="_blank" rel="noopener noreferrer">www.engineeringvillage.com</a>; 
                Scopus, <a href="http://scopus.com" target="_blank" rel="noopener noreferrer">scopus.com</a>, IEEE Xplore, and others). Content of CSCI 2023 will be submitted to the indexing companies for possible indexing.
            </div>


            <h6 className="par_header">Scope & Topics</h6>
            <div className="par">
              Topics of interest include, but are not limited to the following: <br/> <br/>

              <div>
              - ABET Accreditation and assessment (experiences and methods) <br/>
              - Student recruitment and retention methods <br/>
              - Promoting multi-disciplinary initiatives - impact on curriculum <br/>
              - Capstone research projects: examples and case studies <br/>
              - Distance learning; methods, technologies and assessment <br/>
              - Innovative degree programs and certificates <br/>
              - Innovative uses of technology in the classroom <br/>
              - Collaborative learning <br/>
              - Learning models and learning from mistakes <br/>
              - Computer and web-based software for instruction <br/>
              - Incorporating writing into CS curriculum <br/>
              - Preparing graduates for industry <br/>
              - Partnerships with industry and government <br/>
              - Team projects and case studies <br/>
              - Undergraduate research experiences <br/>
              - Student observation and mentoring strategies <br/>
              - Advising methods <br/>
              - Evaluation strategies (professors, students, ...) <br/>
              - Transition to graduate studies <br/>
              - Integrating gender and culture issues into computer science and Engineering curriculum <br/>
              - Issues related to the choice of first programming language <br/>
              - Debugging tools and learning <br/>
              - Projects, software engineering, programming issues, and laboratory practices <br/>
              - Virtual laboratories <br/>
              - Certificate Programs <br/>
              - Active learning tools <br/>
              - Funding opportunities for curriculum development and studies <br/>
              - Pilot studies <br/>
              - STEM (Science, Technology, Engineering & Mathematics) initiatives <br/>
              - Teaching methods <br/>
              - Recruiting methods to attract graduate students <br/>
              - The role of visualization and animation in education <br/>
              - Experiences in the formation of Department Advisory Board <br/>
              - Factors that lead to success in new degree programs <br/>
              - Software Engineering for Embedded Systems in Education
              </div>


            </div>
            
            
          
          </div>
          

        </div>
      </div>
    );
  }
}

export default SympsISED;